<template>
  <div class="employeeManager">
    <h2>
      {{$t('label.titleOrderPage')}}
    </h2>
    <div class="row">
      <div class="col-md-6">
        <div class="d-flex mb-3">
          <span class="no-wrap line_38 font-bold mr-2 minWidth-125">{{$t('label.phoneNumber')}}: </span>
          <b-form-input v-on:keyup="searchOrder()" v-model="phoneNumberSearch" style="max-width: 365px"></b-form-input>
        </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex mb-3">
          <span class="no-wrap line_38 font-bold mr-2 minWidth-125">{{$t('label.deliveryId')}}: </span>
          <b-form-input v-on:keyup="searchOrder()" v-model="deliveryIdSearch" style="max-width: 365px"></b-form-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="d-flex mb-3">
          <span class="no-wrap line_38 font-bold mr-2 minWidth-125">{{$t('label.employee')}}: </span>
          <b-form-select v-on:change="searchOrder()" v-model="saleSearch" :options="optionsSales" style="max-width: 365px"></b-form-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex mb-3">
          <span class="no-wrap line_38 font-bold mr-2 minWidth-125">{{$t('label.deliveryStatus')}}: </span>
          <b-form-select v-on:change="searchOrder()" v-model="deliveryStatusSearch" :options="optionsDeliveryStatus" style="max-width: 365px"></b-form-select>
        </div>
      </div>
    </div>
    <div class="col-md-12 table-counter" style="padding-right: 0"><span class="font-bold">{{this.totalElements}}</span> {{$t('label.tableElements')}}</div>
    <b-table striped bordered head-variant="dark" hover  :items="dataTable" :fields="fields" responsive>
	    <template #cell(action)="data">
	      <a href="javascript:void(0)" v-on:click="editOrder(data.item.idHash, data.item.deliveryId)" style="color: blue">{{$t('label.edit')}}</a>
      </template>
      <template #cell(deliveryStatus)="data">
        <span v-if="data.item.deliveryStatus != null">{{ optionsDeliveryStatus.filter(function (item) {
          return item.value == data.item.deliveryStatus
        })[0].text
          }}</span>
        <span v-else></span>
      </template>
	  </b-table>
	<div class="d-flex">
	  <span class="mr-2 label-page">{{$t('label.pagination.display')}}</span>
	  <b-form-select size="sm" v-on:change="changePerPage()" v-model="selectedPerPage" :options="optionsPages" class="mr-2" style=" max-width: 100px"></b-form-select>
	  <b-pagination
		v-model="currentPage"
		:total-rows="totalElements"
		:per-page="perPage"
		align="left"
		size="sm"
		@change="changePage"
	  ></b-pagination>
	</div>
	<b-modal v-model="openEditModal" size="lg">
	  <template #modal-header="{ close }">
        <h5 class="mb-0">{{$t('label.titleEditOrderNote')}}</h5>
      </template>
      <template>
        <label class="mt-3 font-weight-bold">{{$t('label.deliveryId')}}</label>
		<b-form-input v-model="selectedDeliveryId" :disabled="true"></b-form-input>
		<label class="mt-3 font-weight-bold">{{$t('label.note')}}</label>
		<b-form-textarea v-model="note" rows="5" ></b-form-textarea>
		<div class="error-message w-100 clear text-left">
			{{ msg['note'] ? msg['note'][0] : ''  }}
        </div>
      </template>
      <template #modal-footer class="text-center">
        <b-button size="sm" variant="danger" @click="closeModal">
          {{$t('label.cancel')}}
        </b-button>
        <b-button size="sm" variant="success" @click="updateOrder()">
          {{$t('label.save')}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/axios';
export default {
  data() {
    return {
      width: 0,
      fields: [
        {
          label: this.$t('label.orderId'),
          key: 'id',
          sortable: false
        },
        {
          label: this.$t('label.deliveryId'),
          key: 'deliveryId',
          sortable: false
        },
        {
          label: this.$t('label.deliveryStatus'),
          key: 'deliveryStatus',
          sortable: false
        },
        {
          label: this.$t('label.phoneNumber'),
          key: 'phoneNumber',
          sortable: false
        },
        {
          label: this.$t('label.customerName'),
          key: 'customerName',
          sortable: false
        },
		    {
          label: this.$t('label.calledSale'),
          key: 'saleName',
          sortable: false
        },
		    {
          label: this.$t('label.note'),
          key: 'note',
          sortable: false
        },
		    {
          label: this.$t('label.createdAt'),
          key: 'createdAt',
          sortable: false
        },
		    {
          label: '',
          key: 'action',
          class: 'action',
          sortable: false
        }
      ],
      dataTable: [],
	    selectedPerPage: this.$perPage,
	    perPage: this.$perPage,
      currentPage: 1,
      totalElements: 0,
      orderEdit: '',
      openEditModal: false,
      selectedId: '',
      selectedDeliveryId: '',
      note: '',
      msg: [],
      optionsPages: this.$paginationPages,
      optionsSales: [
        { value: '', text: this.$t('label.all') }
      ],
      optionsDeliveryStatus:[
        { value: 0, text: this.$t('label.all') },
        { value: 7, text: this.$t('label.deliveryStatusList.status7') },
        { value: 8, text: this.$t('label.deliveryStatusList.status8') },
        { value: 9, text: this.$t('label.deliveryStatusList.status9') },
        { value: 10, text: this.$t('label.deliveryStatusList.status10') }
      ],
      phoneNumberSearch: '',
      deliveryIdSearch: '',
      saleSearch: '',
      deliveryStatusSearch: 0
    }
  },
  mounted() {

    this.getListOrder()
    this.getListSale()
    /*window.addEventListener('resize', this.handleResize);
    this.handleResize();*/
  },
  /*destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },*/
  methods: {
    /*handleResize() {
      this.width = window.innerWidth;
      if( this.width < 768){
        this.staked = true;
      } else {
        this.staked = false;
      }
    },*/
    async getListSale() {
      let res
      try {
        res = await apiClient.get('/api/v1/admin/ref/sale/list')
      } catch(error) {
      }
      if (res && res.data) {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++)
            this.optionsSales.push({"value": res.data[i].value, "text": res.data[i].text})
        }
      }
    },
    async getListOrder() {
      let res;
      try {
        res = await apiClient.post('/api/v1/admin/order/list', {
            phoneNumber: this.phoneNumberSearch,
            deliveryId: this.deliveryIdSearch,
            sale: this.saleSearch,
            deliveryStatus: this.deliveryStatusSearch,
            perPage: this.perPage,
			      currentPage: this.currentPage
          }
        )
      } catch(error) {
      }
      if (res && res.data) {
        this.dataTable = res.data.orders
        this.totalElements = res.data.totalElements
      }
    },
    searchOrder() {
      this.currentPage = 1
      this.getListOrder()
    },
    editOrder(id, deliveryId) {
      this.openEditModal = true
      this.msg = []
      this.note = ''
      this.selectedId = id
      this.selectedDeliveryId = deliveryId
    },
    closeModal() {
      this.openEditModal = false
    },
    async updateOrder() {
      let res;
        try {
          res = await apiClient.post('/api/v1/admin/order/note', {
        id: this.selectedId,
        note: this.note
      })
        } catch(error) {
      if (error.response.status == 400) {
            this.msg = (error.response.data);
          }
        }

      if (res && res.data) {
      this.getListOrder()
      this.$bvToast.toast(res.data.message, {
            title: this.$t('label.info'),
            toaster: 'b-toaster-bottom-center',
            variant: 'primary',
            solid: true,
            appendToast: true
          })
      this.openEditModal = false
        }

    },
    changePage(page) {
      this.currentPage = page
      this.getListOrder()
    },
    changePerPage() {
      this.currentPage = 1
      this.perPage = this.selectedPerPage
        this.getListOrder()
    }
  }
}
</script>
<style lang="stylus">
  @media (max-width: 767px) {
    .table.b-table.b-table-stacked > tbody > tr > .action[data-label] > div{
      text-align center;
      width 100%;
    }
  }
  .label-page{
    line-height 34px;
  }
</style>
